/**
 * Grip drag readout state (Faz 11.6 — OCS grip drag coordinate ghost).
 *
 * While a grip drag runs, GripEditLayer publishes the live cursor (client
 * pixels for the DOM balloon position + the constrained world point for the
 * readout). GripReadoutGhost renders it as a cursor-anchored coordinate
 * balloon (the B3 readout source). Transient — nothing persists.
 */

import { create } from 'zustand';

interface GripDragState {
    active: boolean;
    client: { x: number; y: number } | null;
    world: [number, number, number] | null;
    setDrag: (client: { x: number; y: number }, world: [number, number, number]) => void;
    endDrag: () => void;
}

export const useGripDragStore = create<GripDragState>((set) => ({
    active: false,
    client: null,
    world: null,
    setDrag: (client, world) => set({ active: true, client, world }),
    endDrag: () => set({ active: false, client: null, world: null }),
}));
